(() => {
  function init(root = document) {
    root.querySelectorAll('[data-care-assistant]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.querySelectorAll('[data-care-question]').forEach(button => button.addEventListener('click', () => {
        section.querySelectorAll('[data-care-question]').forEach(item => item.setAttribute('aria-expanded', String(item === button)));
        section.querySelectorAll('[data-care-answer]').forEach(answer => { answer.hidden = answer.dataset.careAnswer !== button.dataset.careQuestion; });
      }));
      section.querySelector('[data-care-form]').addEventListener('submit', event => {
        event.preventDefault();
        const input = section.querySelector('input');
        const question = input.value.trim();
        if (!question) { input.setCustomValidity('Please type your question.'); input.reportValidity(); return; }
        window.location.assign('https://wa.me/919877564734?text=' + encodeURIComponent('Hi Miss Care Professional! I need help choosing products. My question: ' + question));
      });
      section.querySelector('input').addEventListener('input', event => event.target.setCustomValidity(''));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
